import React from 'react';
import { useTheme } from '@mui/material/styles';
import { Skeleton, Stack, Card } from '@mui/material';
import styles from './styles';
import { getCookie } from '../../hooks/useCookie';

const CrossSellLoader = ({ disableTitle = false }) => {
  const theme = useTheme();
  return (
    <Stack direction='column' sx={{ justifyContent: 'center', ml: 'auto', mr: 'auto' }}>
      {!disableTitle && (
        <>
          <Skeleton
            variant='rounded'
            height={24}
            width={478}
            sx={{ ml: 'auto', mr: 'auto', mt: '1rem' }}
          />
          <Skeleton
            variant='rounded'
            height={14}
            width={262}
            sx={{ ml: 'auto', mr: 'auto', mt: '1rem' }}
          />
        </>
      )}
      <Stack direction='row' spacing={2} sx={{ justifyContent: 'center', gap: '3%' }}>
        {Array(JSON.parse(getCookie('COMP_MAP'))?.CSPreCardCount <= 1 ? 1 : 2)
          .fill()
          .map((_, index) => (
            <Card
              key={index}
              sx={{
                ...styles(theme).addon_cards,
                width: '26.05rem',
                height: '25rem',
                // ml: 'auto',
                // mr: 'auto',
                backgroundColor: theme.palette.primary.SkeletonBackground,
                mt: '1rem !important',
              }}
            >
              {/* <Stack direction='column'> */}
              <Skeleton
                variant='rounded'
                height={86}
                width={385}
                sx={{
                  m: '1rem auto 0',
                  mt: '18.75rem',
                  backgroundColor: theme.palette.primary.contrastText,
                }}
              />
              {/* </Stack> */}
            </Card>
          ))}
      </Stack>
    </Stack>
  );
};

export default CrossSellLoader;
